/* Initializes the wishlist functions by fetching the list and adding event listeners. */
// Function to set a cookie
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie value
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Function to delete a cookie
function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}

// When the wishlist button is clicked and the user is not logged in
function redirectToLoginWithRedirect() {
    setCookie('postLoginRedirect', '/pages/my-wishlist', 1); // Save the target page in a cookie for 1 day
    window.location.href = '/account/login';
}

// On the account login page (or the page user lands post-login)
function handlePostLoginRedirect() {
    var redirectUrl = getCookie('postLoginRedirect');
    if (redirectUrl) {
        eraseCookie('postLoginRedirect'); // Clear the cookie after use
        window.location.href = redirectUrl; // Redirect to the stored page
    }
}

/* Generate Share URL on Page Load */
const generateShareUrlOnLoad = (swat) => {
  const inputField = document.getElementById('wishlist-share-url');
  if (!inputField) return;

  const listId = window.swymSelectedListId;
  if (!listId) return;

  let onSuccess = (link, lid) => {
  	console.log("Successfully Generated Link ", link, lid);
    const urlObj = new URL(link);
    let paramValue = urlObj.searchParams.get("hkey");
    const targetUrl = "https://argentwork.com/pages/shared-wishlist";
    const currentWindowUrl = new URL(window.location.href);
    // Check if the parameter exists
    const hkeyParameterExists = currentWindowUrl.searchParams.has("hkey");
    
    // Log the result
    if (hkeyParameterExists) {
      paramValue = currentWindowUrl.searchParams.get("hkey")
    }
    
    const targetUrlObj = new URL(targetUrl);
    targetUrlObj.searchParams.append("hkey", paramValue);
        
    inputField.value = targetUrlObj.toString();
  }
  let onError = (error) => {
    // Error is an xhrObject
  	console.log("Error while generating the link", error)
  }

  swat.generateSharedListURL(listId, onSuccess, onError);
}

const init = (swat) => {
  let lists = fetchList(swat);
  if(!window.swymSelectedListId){
     createList(swat);
  }
  addSwymEventListener(swat);
  generateShareUrlOnLoad(swat);
};

/* Create a new wishlist if it doesn't already exist. */

const createList = (swat) => {
    let listConfig = { "lname": "My Wishlist" };
  
    let onSuccess = function({lid}) { 
      console.log("Successfully created a new List", lid);
      window.swymSelectedListId = lid;
      generateShareUrlOnLoad(swat);
    }
    
    let onError = function(error) {
      console.log("Error while creating a List", error);
    }
    
    swat.createList(listConfig, onSuccess, onError);
}

/* Fetches the wishlist data. */

const fetchList = async (swat, removeOrAdd) => {
  return new Promise((resolve, reject) => {
    const onSuccess = (lists) => {
      console.log("Fetched all Lists", lists);
      window.swymWishLists = lists;
      window.swymSelectedListId = lists && lists[0] && lists[0].lid;
      resolve(lists);
      updateButtonState();

      // FILTER invalid products (404)
      (async () => {
        let validItems = [];
      
        for (const item of lists[0].listcontents) {
          try {
            const response = await fetch(`${item.du}.js`);
            if (response.ok) {
              validItems.push(item);
            }
          } catch (e) {
            console.warn("Invalid product deleted:", item);
          }
        }
      
        lists[0].listcontents = validItems;
      
        const wishlistSize = validItems.length;
        window.SwymWishlistCounterControl.updateCount(wishlistSize);
        const submenu = document.getElementById('thb-account-submenu');
      
        if (window.location.pathname === '/pages/my-wishlist' && removeOrAdd) {
          fetchWishlist(); // Function from main-wishlist
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      })();


    };

    const onError = (error) => {
      console.log("Error while fetching all Lists", error);
      reject(error);
    };

    if (!window.swymWishLists) {
      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
      });
    } else {
      resolve(window.swymWishLists);
    }
  });
};


/* Refreshes the wishlist by fetching the list again in the global scope. */

const refreshList = async (swat, removeOrAdd) => {
  window.swymWishLists = null;
  await fetchList(swat, removeOrAdd);
};

/* Adds product to wishlist action. */

const addToWishlist = (swat, product) => {
    let onSuccess = async function (addedListItem){
      const submenu = document.getElementById('thb-account-submenu');

      if (submenu) {
        submenu.classList.add('show-account-submenu'); 

        setTimeout(() => {
          submenu.classList.remove('show-account-submenu');
        }, 2000);
      }

      console.log('Product has been added to wishlist!', addedListItem);
    }
    
    let onError = function (error){
      swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
    }

    let lid = window.swymSelectedListId;
    swat.addToList(lid, product, onSuccess, onError);

}

/* Remove product from wishlist action. */

const removeFromWishlist = (swat, product) => {
  let onSuccess = async function(deletedProduct) {
    console.log('Product has been removed from wishlist!', deletedProduct);
  }
  
  let onError = function(error) {
    swat.ui.showErrorNotification({ message: "Error removing Product from Wishlist" });
  }

  let lid = window.swymSelectedListId;

  swat.deleteFromList(lid, product, onSuccess, onError);
}

/* Updates the state of wishlist buttons based on whether items are wishlisted. */

const updateButtonState = () => {
  const swymWishlistButtons = document.querySelectorAll('swymcs-wishlist-button');

  if (swymWishlistButtons) {
    swymWishlistButtons.forEach((swymWishlistButton) => {
      const elements = swymWishlistButton.elements;
      const { epi, empi } = elements.wishlistButton.dataset;
      let isWishlisted = false;

      if (window.swymWishLists) {
        window.swymWishLists.forEach(list => {
          list.listcontents.forEach(item => {
            if (item.empi == empi && item.epi == epi) {
              isWishlisted = true;
            }
          });
        });
        updateButtonWishlistState(elements, isWishlisted);
      }
    });
  }
};

/* Updates the display state of a wishlist button based on whether the item is wishlisted. */

const updateButtonWishlistState = (elements, isWishlisted) => {
  elements.filledState.style.display = isWishlisted ? 'flex' : 'none';
  elements.unfilledState.style.display = isWishlisted ? 'none' : 'flex';
  if (isWishlisted) {
    elements.wishlistButton.classList.add('swym-added-custom');
  } else {
    elements.wishlistButton.classList.remove('swym-added-custom');
    elements.wishlistButton.classList.remove('disabled');
    elements.wishlistButton.removeAttribute('disabled');
  }
};

/* Render multiple wishlist popup when multiple wishlist enabled */

const renderPopup = async(product) => {
  let popup = document.querySelector('swym-wishlist-popup');
  let { epi, empi, du} = product;
  window.currentActiveProduct = await fetchProductsData(du);
  window.currentActiveVariant =  currentActiveProduct.variants.find((variant) => variant.id == epi);
  window.currentActiveVariantId = epi;
  window.currentActiveProduct.url = du;
  setTimeout(popup._show.bind(popup), 100);
} 

/* Fetches product data from shopify to get updated data. */

const fetchProductsData = async (url) => {
  const productData = await fetch(`${url}.js`);
  if (productData.status === 404 || !productData.ok) return null;
  const jsonData = await productData.json();
  return jsonData;
};

/* Adds event listeners for wishlist actions. */

const addSwymEventListener = (swat) => {
  
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, (event) => {
    let image = event.detail.d.iu;
    let title = event.detail.d.dt;
    //showCustomNotification(swat, image, title, 'remove', 1);
    refreshList(swat, true); 
  });
  
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (event) => {
    let image = event.detail.d.iu;
    let title = event.detail.d.dt;
    // showCustomNotification(swat, image, title, 'add', 1);
    refreshList(swat, true);
  });

  console.log(swat.JSEvents.variantChanged);
  
  swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
    const currentVariant = data.detail.d.variant.id;
    const currentProductId = data.detail.d.product.id;
    const swymCustomWishlistButton = document.querySelector(`.swymcs-wishlist-button-${currentProductId}`);
    if (swymCustomWishlistButton) {
      swymCustomWishlistButton.setAttribute('data-epi', currentVariant);
    }
    setTimeout(updateButtonState, 200);
  });
};

const showCustomNotification = ( swat, image, title, action, listCount ) => {
      let successMessage = `
      <style>
          .swym-notification-success-inner .swym-image{ display: none !important }
          #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
          #swym-custom-notification-content #swym-custom-image-container { min-height: 50px; min-width: 50px; max-height: 50px; max-width: 50px }
          #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; border-radius: 50% }
          #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
      </style>
      <div id="swym-custom-notification-content" onclick="_swat.ui.open()">
          <a id="swym-custom-notification-content-link" href="/pages/my-wishlist"> 
            <div id="swym-custom-image-container">
              <img id="swym-custom-image" src="${image}" alt="wishlisted product image"/>
            </div>
            <div id="swym-custom-title-conatainer"><strong>${title}</strong> has been ${action=='remove'?'removed from':'added to'} <strong> ${listCount == 1 ? 'list!' : 'lists!'}</strong></div>
          </a>
      </div>
    `;
    swat.ui.showSuccessNotification({ message: successMessage });
}


/* Creating a global object to assign functions */

const swymcsWishlistFunctions = {
  init,
  fetchList,
  refreshList,
  updateButtonState,
  updateButtonWishlistState,
  addToWishlist,
  removeFromWishlist,
  addSwymEventListener,
  fetchProductsData,
  renderPopup,
  showCustomNotification
};

/* Push the init functions into SwymCallbacks  */

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymcsWishlistFunctions.init);

/* Expose swymcsWishlistFunctions to the global scope */

window.swymcsWishlistFunctions = swymcsWishlistFunctions;

// Ensure the Swym script is ready
document.addEventListener('swym:ready', function () {
  // Fetch the wishlist data
  _swat.fetchWrtWishlistItems(function (wishlistItems) {
    // Get the count of items
    var wishlistCount = wishlistItems.length;
    
    // Display the count in the HTML element
    document.getElementById('wishlist-count').innerText = wishlistCount;
  });
});

if (!customElements.get('swymcs-wishlist-button')) {
  class SwymWishlistButton extends HTMLElement {
    constructor() {
      super();

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(this.initializeSwymButton.bind(this));

      // Add listener for custom "update" event
      this.addEventListener('update', this.reinitialize.bind(this));
    }

    async initializeSwymButton(swat) {
      var swymWishlistButtonElement = this;
      this.elements = {
        wishlistButton: swymWishlistButtonElement.querySelector('button'),
        unfilledState: swymWishlistButtonElement.querySelector('.swymUnfilled'),
        filledState: swymWishlistButtonElement.querySelector('.swymFilled'),
      };

      this.elements.wishlistButton.addEventListener('click', () => {
        let { epi, empi, du } = this.elements.wishlistButton.dataset;
        let product = { epi, empi, du };

        if (swat.isCollectionsEnabled()) {
          swymcsWishlistFunctions.renderPopup(product);
        } else {
          if (this.elements.wishlistButton.classList.contains('swym-added-custom')) {
            swymcsWishlistFunctions.removeFromWishlist(swat, product);
          } else {
            swymcsWishlistFunctions.addToWishlist(swat, product);
          }
        }

        if (!this.elements.wishlistButton.hasAttribute('data-logged-in')) {
          const url = window.location.href;
          const afterDomain = url.split('.com')[1];
          console.log('afterDomain', afterDomain);

          setCookie('postLoginRedirect', `${afterDomain}`, 1);

          window.location.href = '/account/login';
        }
      });
    }

    // Reinitialize function
    reinitialize() {
      swymcsWishlistFunctions.updateButtonState();
    }
  }

  customElements.define('swymcs-wishlist-button', SwymWishlistButton);
}

/* Global wishlist counter controller*/

window.SwymWishlistCounterControl = {
  isUpdating: false,

  updateCount: function(count) {
    if (this.isUpdating) return;
    this.isUpdating = true;

    const wishlistCountEl = document.getElementById('my-wishlist-size') || document.getElementById('wishlist-count');
    if (!wishlistCountEl) return;

    wishlistCountEl.innerText = count;
    wishlistCountEl.style.display = count > 0 ? 'inline-flex' : 'none';

    // Update icons (adjust selectors according to your HTML)
    const emptyHeart = document.querySelector('.alh-empty__heart');
    const filledHeart = document.querySelector('.alh-fill__heart');
    if (emptyHeart && filledHeart) {
      emptyHeart.style.display = count > 0 ? 'none' : 'block';
      filledHeart.style.display = count > 0 ? 'block' : 'none';
    }

    // Update classes or containers if you use tabs, etc. 
    const cartTabsEl = document.querySelector('.cart-tabs');
    if (cartTabsEl) {
      cartTabsEl.classList.toggle('has-products-wishlist', count > 0);
    }

    // Allow new updates after a period of time to avoid permanent blocking.
    setTimeout(() => {
      this.isUpdating = false;
    }, 1000);
  }
};
